import '@/assets/main.css';
import 'primeicons/primeicons.css';
import appFactory from './app';
import App from './AppLayout.vue';
import { useProjectStore } from './stores/project';
import { useAppApi, config as apiConfig } from './plugins/appApi';
import keycloakConfig from '@/config/keycloak';

const preconnectApi = document.createElement('link');
preconnectApi.setAttribute('rel', 'preconnect');
preconnectApi.setAttribute('href', apiConfig.appApiBaseUrl);

const preconnectKeycloak = document.createElement('link');
preconnectKeycloak.setAttribute('rel', 'preconnect');
preconnectKeycloak.setAttribute('href', keycloakConfig.url);

document.getElementsByTagName('head')[0].prepend(preconnectApi);
document.getElementsByTagName('head')[0].prepend(preconnectKeycloak);

appFactory(App, async () => {
  const client = useAppApi();

  const projects = await client.GET('/api/projects');

  if (projects.error) {
    throw 'Failed to bootstrap app!';
  }

  const uid = assertOneProjectReturned(projects.data);

  useProjectStore().setProjectUid(uid);

  document.getElementsByClassName('layout-mask')[0].classList.add('display-none');
  setTimeout(() => {
    document.getElementsByClassName('layout-mask')[0].remove();
  }, 200);
});

function assertOneProjectReturned(projectUids: string[] | undefined): string {
  if (!projectUids) {
    throw 'Failed to bootstrap app! Project data was empty!';
  }

  if (projectUids.length > 1) {
    // We expect only one project in first phase
    throw 'Failed to bootstrap app! More than one project returned!';
  }

  if (projectUids.length === 0) {
    throw 'Failed to bootstrap app! No projects returned!';
  }

  return projectUids[0];
}
